import { executeGetNoResultError } from '../common/apiCaller'
import { GetUseReasonDto } from '../dto/useReasonDto'

const apiName = 'public'
const apiPath = '/use-reason'

export const executeGetUseReason = () => {
  return executeGetNoResultError<GetUseReasonDto>(apiName, apiPath)
}
